import { types, actions } from './requests'
export const GETLISTINGFORWORKER_TYPES = {
    ...types('GETLISTINGFORWORKER'),
}
export const GETLISTINGFORWORKER_ACTIONS = {
    ...actions('GETLISTINGFORWORKER'),
}